module.exports = am4plugins_sliceGrouper;